import { render, staticRenderFns } from "./LeadsKanban.vue?vue&type=template&id=950d6aaa&scoped=true&"
import script from "./LeadsKanban.vue?vue&type=script&lang=js&"
export * from "./LeadsKanban.vue?vue&type=script&lang=js&"
import style0 from "./LeadsKanban.vue?vue&type=style&index=0&id=950d6aaa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "950d6aaa",
  null
  
)

export default component.exports